var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebookLtr = function SvgSocialFacebookLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 49.14C88.5 28.35 71.713 11.5 51 11.5S13.5 28.35 13.5 49.14c0 17.643 12.114 32.464 28.447 36.537v-25.04h-7.734V49.14h7.734v-4.955c0-12.807 5.772-18.747 18.31-18.747 2.374 0 6.475.47 8.16.941v10.41c-.879-.088-2.417-.147-4.336-.147-6.152 0-8.525 2.338-8.525 8.41v4.088h12.246l-2.11 11.497H55.541V86.5C74.115 84.25 88.5 68.386 88.5 49.14"
  })));
};
export default SvgSocialFacebookLtr;